
import Vue from 'vue'
export default Vue.extend({
  name: 'SignalStrength',
  props: {
    rssiValue: Number,
    sensorType: String,
  },
  computed: {
    signalStrength(): string {
      let signalStrength = "";
      // These sensors actually send LQI instead of rssi
      if (this.sensorType === 'door-v1' || this.sensorType === 'infrared-v1') {
        switch (true) {
          case this.rssiValue > 70:
            return "high"
          case this.rssiValue > 54:
            return "medium"
          case this.rssiValue > 39:
            return "low"
          default:
              return "none"
        }
      }
      if ( this.sensorType === 'door-v2') {
        switch (true) {
          case this.rssiValue < -50:
            signalStrength = "none"
            break;
          case this.rssiValue < -30:
            signalStrength = "low";
            break;
          case this.rssiValue < -15:
            signalStrength = "medium";
            break;

          case this.rssiValue < 0:
            signalStrength = "high";
            break;
          default:
            signalStrength = "none"
        }
      } else {
        switch (true) {
          case this.rssiValue <= -81:
            signalStrength = "none"
            break;
          case this.rssiValue <= -71:
            signalStrength = "low";
            break;
          case this.rssiValue <= -61:
            signalStrength = "medium";
            break;
          case this.rssiValue <= 0:
            signalStrength = "high";
            break;
          default:
            signalStrength = "none"
        }
      }
      return signalStrength;
    }
  }
})
